import React from 'react'
import { Form } from 'semantic-ui-react'

export default class LocationField extends React.PureComponent {
  render() {
    const { value, field, label, onChange } = this.props

    return (
      <Form.Input
        label={label}
        placeholder={label === 'lat' ? 'Latitude' : 'Longitude'}
        required
        type="number"
        onChange={e => onChange(field, e.target.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/locationField.js